import { resolveComponent as n, createElementBlock as e, openBlock as s, createVNode as c, createElementVNode as t, normalizeClass as d, createCommentVNode as r, renderSlot as i } from "vue";
/* empty css                 */
import l from "../../_virtual/_plugin-vue_export-helper.js";
import m from "../../utils/mixins/screen/screen.vue.js";
import _ from "../../atoms/divider/divider.vue.js";
const g = {
  name: "DsPageFooter",
  components: { DsDivider: _ },
  mixins: [m],
  provide() {
    return {
      trackingData: { "component-name": this.$options.name }
    };
  }
}, p = { class: "ds-page-footer ds-background-color-white" }, f = { class: "ds-grid ds-page-footer__bottom" }, u = { class: "ds-grid__col ds-grid__col--12 ds-page-footer__bottom-row" }, v = {
  key: 0,
  class: "ds-margin-bottom-48 ds-md-margin-bottom-0 ds-align-items-center"
}, h = {
  key: 1,
  class: "ds-grid ds-page-footer__legal-disclaimer"
}, $ = { class: "ds-grid__col ds-grid__col--12 ds-text-small ds-color-black" };
function b(o, D, k, w, y, N) {
  const a = n("DsDivider");
  return s(), e("section", p, [
    c(a, { theme: "light" }),
    t("div", {
      class: d(["ds-container ds-padding-top-48 ds-md-padding-top-96 ds-background-color-white ds-page-footer__container", { "ds-page-footer__container--switcher": !!o.$slots.localeSwitcher }])
    }, [
      o.$slots.primaryNavigation ? (s(), e("div", {
        key: 0,
        class: d(["ds-margin-bottom-48 ds-md-margin-bottom-96 ds-lg-margin-bottom-144", { "ds-align-items-center": !o.$slots.primaryNavigation }])
      }, [
        i(o.$slots, "primaryNavigation", {}, void 0, !0)
      ], 2)) : r("", !0),
      t("div", f, [
        t("div", u, [
          i(o.$slots, "secondaryNavigation", {}, void 0, !0),
          o.$slots.localeSwitcher ? (s(), e("div", v, [
            i(o.$slots, "localeSwitcher", {}, void 0, !0)
          ])) : r("", !0)
        ])
      ]),
      o.$slots.legalDisclaimer ? (s(), e("div", h, [
        t("div", $, [
          i(o.$slots, "legalDisclaimer", {}, void 0, !0)
        ])
      ])) : r("", !0)
    ], 2)
  ]);
}
const F = /* @__PURE__ */ l(g, [["render", b], ["__scopeId", "data-v-0bb76f31"]]);
export {
  F as default
};
